import React, { useState, ReactNode } from "react";
import { Controller } from "react-hook-form";
import { Input, Label, Button } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ControlledTextFieldProps {
  label: ReactNode;
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  onClick?: any;
  onBlur?: any;
}

type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color";

const ControlledTextField: React.FC<ControlledTextFieldProps> = ({
  label,
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
  onClick,
  onBlur
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="align-items-between">
      <Label
        className={`${label === "" ? "pt-1" : ""} form-label`}
        htmlFor={inputName}
      >
        {isRequired ? `${label}` : label}
      </Label>
      <div className="d-flex flex-row align-items-end">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => (
            <>
              <Input
                id={inputName}
                type={showPassword ? "text" : (inputType as MyInputType)}
                placeholder={placeholder}
                invalid={invalid}
                disabled={isDisabled}
                {...field}
                defaultValue={defaultValue}
                className={className}
                onClick={onClick}
                onBlur={onBlur}
              />
              {inputType === "password" && (
                <Button onClick={togglePasswordVisibility} className="ms-2">
                  {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                </Button>
              )}
            </>
          )}
        />
        {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
      </div>
      {invalid && (
        <ValidationMsgComponent
          inputName={inputName}
          invalid={invalid}
          errors={errors}
          rules={rules}
        />
      )}
    </div>
  );
};

export default ControlledTextField;
